import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  class: "w100 llgreyBg",
  style: {"height":"40px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "w100 pad15"
}
const _hoisted_9 = { class: "w100" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "所要時間"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_11 = {
  class: "fl w60 mt20",
  style: {}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "w100 mt40"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "候補の表示間隔"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_15 = { class: "fl w60" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = { class: "w100 mt40" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "調整可能時間を設定"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_19 = {
  class: "fl w60",
  style: {}
}
const _hoisted_20 = { class: "selectTableView" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { width: "400" }, null, -1)
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  style: {"width":"30px"},
  class: "fl"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "fs14 fw600" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  class: "fr grey",
  style: {"margin-right":"20px"}
}, "で調整可能", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = { class: "selectTableView w100" }
const _hoisted_30 = { class: "pad10 mt20" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "header_title fs14 mt" }, "カスタム設定", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = {
  key: 1,
  class: "w100 mt40"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "日程を確定しないお相手の提案下限件数"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt20" }, [
    /*#__PURE__*/_createTextVNode(" 日程を確定できないお相手が、候補を提案してもらう場合に下限の件数を表示します。 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("下限の件数より提案数が少ない場合、提案前に"),
    /*#__PURE__*/_createElementVNode("b", null, "アラートが表示"),
    /*#__PURE__*/_createTextVNode("されます。 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("下限件数が0の場合、特に指定しません。 ")
  ]),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_36 = { class: "fl w60" }
const _hoisted_37 = { style: {"width":"90px","margin-top":"10px"} }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = {
  key: 2,
  class: "w100 mt40",
  style: {}
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "メールに記載する日程候補数"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt20" }, " お相手が確定できる場合に、その確定できる日程候補をメール上で表示する最大件数を設定できます。 "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_42 = { class: "fl w60" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = {
  key: 3,
  class: "w100 mt40",
  style: {}
}
const _hoisted_47 = { class: "fl w30 pad10" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "調整相手のイベント登録設定", -1)
const _hoisted_49 = { class: "mt20" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = { class: "fl w60" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_57 = {
  key: 4,
  class: "w100 mt40",
  style: {}
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "調整カレンダー編集時のタイムゾーン設定"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt20" }, "調整カレンダー編集時のタイムゾーンを変更します。"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_59 = { class: "fl w60" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = {
  key: 5,
  class: "w100 mt40"
}
const _hoisted_64 = { class: "fl w30 pad10" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h5", { class: "" }, "連携している外部カレンダーを更新", -1)
const _hoisted_66 = { class: "mt20" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = { class: "fl w60" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_74 = {
  key: 6,
  class: "w100 mt40",
  style: {}
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "alertRed" }, "カレンダー連携を解除"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt20" }, [
    /*#__PURE__*/_createTextVNode(" 連携している外部カレンダー連携を解除します。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" すでに作成済みの調整カレンダーに外部カレンダーが利用されている場合、自動的に解除されます。 ")
  ]),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_76 = { class: "fl w60" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_79 = {
  class: "w100 mt40",
  style: {}
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "公開ページのオーナーをまとめて移行する"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt20" }, [
    /*#__PURE__*/_createTextVNode(" 公開ページのオーナーをまとめて移行します。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 公開ページに紐づく調整カレンダーも自動でオーナーが変更されます。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "orange fw600" }, [
      /*#__PURE__*/_createTextVNode("※ waaq内共有でない、個人の外部カレンダーを利用している場合、自動的に連携が解除されます。新オーナーにて、カレンダーの連携をし直してください。"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" また、移行完了後、元のオーナーで作成された調整ページに関しては、オーナーの変更が行われないため再調整・担当者変更等ができませんのでご注意ください。 ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_81 = { class: "fl w60" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_83 = { key: 1 }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_UserSettingsHeader = _resolveComponent("UserSettingsHeader")!
  const _component_MeetingTimeContent = _resolveComponent("MeetingTimeContent")!
  const _component_AvailableStepSizeContent = _resolveComponent("AvailableStepSizeContent")!
  const _component_AvailableDaysOfWeeksTableCell = _resolveComponent("AvailableDaysOfWeeksTableCell")!
  const _component_ModalInnerAvailableTime = _resolveComponent("ModalInnerAvailableTime")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_TimezoneSelectContent = _resolveComponent("TimezoneSelectContent")!
  const _component_UserSettingsNotAttendCalendar = _resolveComponent("UserSettingsNotAttendCalendar")!
  const _component_RefreshCalendarModal = _resolveComponent("RefreshCalendarModal")!
  const _component_ChangeOwnerMyPublicRoomsModal = _resolveComponent("ChangeOwnerMyPublicRoomsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `settings` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_UserSettingsHeader, {
                selectedTab: _ctx.selectedTab,
                ref: "header"
              }, null, 8, ["selectedTab"]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${
                                _ctx.selectedCategory == `defaultSettings` ? `fw600 selected` : ``
                            }`),
                  style: {"width":"120px"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategory(`defaultSettings`)))
                }, " デフォルト設定 ", 2),
                false
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(`fs12 mt2 fl pointer pad10 ${
                                _ctx.selectedCategory == `notAttendCalendar` ? `fw600 selected` : ``
                            }`),
                      style: {"width":"140px"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategory(`notAttendCalendar`)))
                    }, " 不参加カレンダー ", 2))
                  : _createCommentVNode("", true),
                _hoisted_6
              ]),
              _hoisted_7,
              (_ctx.selectedCategory == `defaultSettings`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_MeetingTimeContent, {
                          from: _ctx.from,
                          appo: _ctx.appo,
                          onUpdateAppo: _ctx.updateMeetingTime
                        }, null, 8, ["from", "appo", "onUpdateAppo"])
                      ]),
                      _hoisted_12
                    ]),
                    (_ctx.us)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_AvailableStepSizeContent, {
                              class: "mt20",
                              from: _ctx.from,
                              autoSave: false,
                              hideTitle: true,
                              onUpdate: _ctx.updateStepSize
                            }, null, 8, ["from", "onUpdate"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("table", _hoisted_20, [
                          _hoisted_21,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectTimeThemes, (theme, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `${index}${theme.systemUpdatedAt}${theme.select}`,
                              height: "45",
                              class: _normalizeClass(`dataEmail ${theme.select == true ? `selected` : ``}`),
                              style: {"border-bottom":"1px solid #efefef","line-height":"45px"}
                            }, [
                              _createElementVNode("td", {
                                onClick: ($event: any) => (_ctx.selectTheme(theme))
                              }, [
                                _createTextVNode("    "),
                                _createElementVNode("div", _hoisted_23, [
                                  _createTextVNode("     "),
                                  (theme.select)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "✔"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_25, " "))
                                ]),
                                _createElementVNode("span", _hoisted_26, _toDisplayString(theme.text), 1),
                                _hoisted_27
                              ], 8, _hoisted_22)
                            ], 2))
                          }), 128)),
                          _hoisted_28,
                          _createElementVNode("table", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayAdows, (adow, adowindex) => {
                              return (_openBlock(), _createBlock(_component_AvailableDaysOfWeeksTableCell, {
                                key: `${adow.systemUpdatedAt}${adowindex}`,
                                adow: adow,
                                onDeleteAdow: _ctx.deleteAdow,
                                showDeleteButton: true
                              }, null, 8, ["adow", "onDeleteAdow"]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createVNode(_component_ModalInnerAvailableTime, {
                              direct: true,
                              onUpdate: _ctx.addAdow
                            }, null, 8, ["onUpdate"])
                          ])
                        ])
                      ]),
                      _hoisted_32
                    ]),
                    _hoisted_33,
                    (_ctx.us)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_MdTextfieldTag, {
                                name: "下限件数を入力",
                                style: {"height":"56px","min-width":"90px"},
                                class: "fl fs14",
                                value: _ctx.us && _ctx.us.submit_lower_limit_num ? _ctx.us.submit_lower_limit_num : 0,
                                type: "number",
                                min: 0,
                                onInputValue: _ctx.inputSubmitNum,
                                required: ""
                              }, null, 8, ["value", "onInputValue"])
                            ])
                          ]),
                          _hoisted_38
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_39,
                    (_ctx.us)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_component_SelectTag, {
                              name: "meeting_time",
                              id: "select_meeting_time",
                              class: "fl fs14 roundForm",
                              style: {"min-width":"130px","height":"50px","margin-top":"10px"},
                              options: _ctx.CalendarUtil.selectDisplayPossibleDatesNum,
                              defaultOption: _ctx.us.email_suggests_num,
                              onSelectValue: _ctx.selectDisplayPossibleDatesEmailNum
                            }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                            _hoisted_43
                          ]),
                          _hoisted_44
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_45,
                    (_ctx.us && _ctx.rm.didConnectCal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("p", _hoisted_49, [
                              _createTextVNode(" 調整相手が確定した際に、 自分と同じ"),
                              (_ctx.rm.did_connect_ms_cal)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Microsoft予定表"))
                                : (_ctx.rm.did_connect_google_cal)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, "Googleカレンダー"))
                                  : _createCommentVNode("", true),
                              _createTextVNode("上のイベントの同席者として書き込まれ、お相手のカレンダー上でもイベントが確認できるようになります。 "),
                              _hoisted_52,
                              _createTextVNode("もしお相手に予定を見られたくない場合は、「オーナーと別イベントとして作成」を選んでください。 ※「オーナーと別イベントとして作成」する場合、お相手がwaaqでカレンダー連携していない場合、自動的にイベントを作成できません ")
                            ]),
                            _hoisted_53
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_SelectTag, {
                              name: "meeting_time",
                              id: "select_meeting_time",
                              class: "fl fs14 roundForm",
                              style: {"min-width":"330px","height":"50px","margin-top":"10px"},
                              options: _ctx.CalendarUtil.selectAddEventTypes.map(t => t.name),
                              defaultOption: 
                                        _ctx.CalendarUtil.selectAddEventTypes.find(t => t.type == (_ctx.us.add_event_type || `same_event`))
                                            .name
                                    ,
                              onSelectValue: _ctx.selectAddEventType
                            }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                            _hoisted_55
                          ]),
                          _hoisted_56
                        ]))
                      : _createCommentVNode("", true),
                    (false && _ctx.us)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _hoisted_58,
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_TimezoneSelectContent, {
                              class: "mt20",
                              defaultTimezone: _ctx.us.timezone_value,
                              onSelectTimezone: _ctx.selectTimezone
                            }, null, 8, ["defaultTimezone", "onSelectTimezone"]),
                            _hoisted_60
                          ]),
                          _hoisted_61
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_62,
                    (_ctx.rm.didConnectCal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _hoisted_65,
                            _createElementVNode("p", _hoisted_66, [
                              _createTextVNode(" 連携している外部カレンダー"),
                              (_ctx.rm.calendar_account_name)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_67, "（" + _toDisplayString(_ctx.rm.calendar_account_name) + "）", 1))
                                : _createCommentVNode("", true),
                              _createTextVNode("を更新します。"),
                              _hoisted_68,
                              _createTextVNode(" すでに作成済みの調整カレンダーに外部カレンダーが利用されている場合、自動的に解除されます。 ")
                            ]),
                            _hoisted_69
                          ]),
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("button", {
                              type: "submit",
                              class: "pointer centered circle_button blueAround fs16 rad8 mt15 ml20",
                              style: {"width":"120px","height":"50px","padding":"14px 8px"},
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.refreshCalendar && _ctx.refreshCalendar(...args)))
                            }, " 更新する "),
                            _hoisted_71
                          ]),
                          _hoisted_72
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_73,
                    (_ctx.us && _ctx.rm.didConnectCal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _hoisted_75,
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("button", {
                              type: "submit",
                              class: "pointer centered circle_button alertRedAround fs16 rad8 mt15 ml20",
                              style: {"width":"120px","height":"50px","padding":"14px 8px"},
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.disconnectCalendar && _ctx.disconnectCalendar(...args)))
                            }, " 解除する "),
                            _hoisted_77
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_78,
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _createElementVNode("div", _hoisted_81, [
                        _createVNode(_component_MdTextfieldTag, {
                          placeholder: "新オーナーのメールアドレス",
                          style: {"border-bottom":"solid 1px #c8c8c8"},
                          class: "cal_blanks fw600 fl fs12 mr5 w30 mt15",
                          id: "new_owner_email",
                          value: _ctx.memberEmail,
                          onInputValue: _ctx.inputChangeOwnerEmail,
                          errMessage: _ctx.failedMail ? `不正なメールアドレスです` : null
                        }, null, 8, ["value", "onInputValue", "errMessage"]),
                        (_ctx.showChangeOwnerButton)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "pointer centered circle_button skyblueBg fs16 rad8 ml10 mt20",
                              style: {"width":"180px","height":"50px","padding":"14px 8px"},
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeOwnerMyPublicRooms && _ctx.changeOwnerMyPublicRooms(...args)))
                            }, " オーナーを移行 "))
                          : _createCommentVNode("", true),
                        _hoisted_82
                      ])
                    ])
                  ]))
                : (_ctx.selectedCategory == `notAttendCalendar`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _createVNode(_component_UserSettingsNotAttendCalendar)
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_84
    ]),
    _createVNode(_component_RefreshCalendarModal, { onRefreshedCalInfo: _ctx.refreshedCalInfo }, null, 8, ["onRefreshedCalInfo"]),
    _createVNode(_component_ChangeOwnerMyPublicRoomsModal, {
      email: _ctx.memberEmail,
      onRequestedChangeOwner: _ctx.requestedChangeOwner
    }, null, 8, ["email", "onRequestedChangeOwner"])
  ]))
}